import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { AppContext } from 'App';
import { InWellContainer } from 'app/components/layout/in-well-container';
import { ModalContainer } from 'app/components/layout/modal-container';
import { trackEvent, getLocationDetails } from 'lib/analytics';

export const FormContainer = ({
  alternativeScene,
  children,
}: {
  alternativeScene?: 'login' | 'sign-up';
  children: React.ReactNode;
}) => {
  const { iframeLocation, isDismissable } = React.useContext(AppContext);

  const location = useLocation();
  const history = useHistory();

  const onLoginLinkClicked = () => {
    trackEvent('auth_click', {
      action: 'onLoginLinkClicked',
      ...getLocationDetails(location.pathname, location.search),
    });
    history.push('/login');
  };

  const onSignUpLinkClicked = () => {
    trackEvent('auth_click', {
      action: 'onSignUpLinkClicked',
      ...getLocationDetails(location.pathname, location.search),
    });
    history.push('/sign-up');
  };

  switch (iframeLocation) {
    case 'in-well': {
      return (
        <InWellContainer
          alternativeScene={alternativeScene}
          onLoginLinkClicked={onLoginLinkClicked}
          onSignUpLinkClicked={onSignUpLinkClicked}
        >
          {children}
        </InWellContainer>
      );
    }
    default: {
      return (
        <ModalContainer
          withCloseButton={isDismissable}
          alternativeScene={alternativeScene}
          onLoginLinkClicked={onLoginLinkClicked}
          onSignUpLinkClicked={onSignUpLinkClicked}
        >
          {children}
        </ModalContainer>
      );
    }
  }
};
